import { REGULATOR } from 'constants/regulators';

export const CHANGE_PASSWORD_FORM = 'CHANGE_PASSWORD_FORM';

export const PROFILE_DETAILS_FORM = 'PROFILE_DETAILS_FORM';
export const BANK_DETAILS_SEARCH_FORM = 'BANK_DETAILS_SEARCH_FORM';

export const EDIT_OTHER_DOCUMENTS_FORM = 'EDIT_OTHER_DOCUMENTS_FORM';
export const EDIT_OTHER_DOCUMENTS_MODAL = 'EDIT_OTHER_DOCUMENTS_MODAL';

export const CREATE_BANK_DETAILS_FORM = 'CREATE_BANK_DETAILS_FORM';
export const CREATE_BANK_DETAILS_MODAL = 'CREATE_BANK_DETAILS_MODAL';
export const DELETE_BANK_DETAILS_MODAL = 'DELETE_BANK_DETAILS_MODAL';

export const CREATE_AUTHORISED_PERSON_FORM = 'CREATE_AUTHORISED_PERSON_FORM';
export const CREATE_AUTHORISED_PERSON_MODAL = 'CREATE_AUTHORISED_PERSON_MODAL';
export const DELETE_AUTHORISED_PERSON_MODAL = 'DELETE_AUTHORISED_PERSON_MODAL';

export const PROFILE_CHANGE_PASSWORD_MODAL = 'PROFILE_CHANGE_PASSWORD_MODAL';
export const EMAIL_NOTIFICATION_MODAL = 'EMAIL_NOTIFICATION_MODAL';
export const SUBSCRIPTION_COMPLIANCE_STATE_MODAL = 'SUBSCRIPTION_COMPLIANCE_STATE_MODAL';
export const UNSUBSCRIBE_MODAL_SUCCESS = 'UNSUBSCRIBE_MODAL_SUCCESS';

export const AUTHORISED_PERSON_RELATIONSHIP = {
  traderMoneyManager: 'trader_money_manager',
  spouse: 'spouse',
  friend: 'friend',
  businessPartner: 'business_partner',
  familyMember: 'family_member',
  other: 'other',
};

export const TRADING_WITH_MAPPER = {
  [REGULATOR.ASIC]: ['Fusion Markets AU'],
  [REGULATOR.VFSC]: ['Fusion Markets EN', 'Vanuatu 40256'],
  [REGULATOR.SEY]: ['Fusion Markets International', 'Ltd Seychelles SD096'],
  [REGULATOR.CYSEC]: ['Fusion Markets EU', 'Cyprus'],
};

export const PRO_TRADING_WITH_MAPPER = {
  [REGULATOR.ASIC]: ['Fusion Markets AU (Pro)'],
  [REGULATOR.VFSC]: ['Fusion Markets', 'EN Vanuatu 40256 (Pro)'],
  [REGULATOR.SEY]: ['Fusion Markets International', 'Ltd Seychelles SD096 (Pro)'],
  [REGULATOR.CYSEC]: ['Fusion Markets EU', 'Cyprus'],
};

export const EMAIL_NOTIFICATIONS_SETTINGS_FORM = 'EMAIL_NOTIFICATIONS_SETTINGS_FORM';

export const TABLE_FILTERS_INITAL_VALUES = {
  search: '',
};
